export default __webpack_public_path__ + "static/media/LogoTipografico_Color.134a02e3.svg";